/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
export type DesignProfileStatus = "ACTIVE" | "DELETED" | "NEW" | "PENDING" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type ProfileShowcase_tradeFirm$ref: FragmentReference;
export type ProfileShowcase_tradeFirm = {|
  +profileStatus: ?DesignProfileStatus,
  +publicProfile: ?{|
    +urlLabel: ?string
  |},
  +rewards: ?{|
    +profileAwarenessPlacements: ?{|
      +moduleTitle: ?string,
      +ctaCopy: ?string,
      +bodyCopy: ?string,
    |}
  |},
  +$refType: ProfileShowcase_tradeFirm$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "ProfileShowcase_tradeFirm",
  "type": "TradeFirmType",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "profileStatus",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "publicProfile",
      "storageKey": null,
      "args": null,
      "concreteType": "TradeFirmPublicProfileType",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "urlLabel",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "rewards",
      "storageKey": null,
      "args": null,
      "concreteType": "TradeFirmRewards",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "profileAwarenessPlacements",
          "storageKey": null,
          "args": null,
          "concreteType": "ProfileAwarenessPlacementType",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "moduleTitle",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "ctaCopy",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "bodyCopy",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'a2ebb8bb882c6379feec019e29024a28';
module.exports = node;
